import { Component, JSX, Prop, h } from '@stencil/core'

@Component({
  tag: 'air-badge',
  styleUrl: 'air-badge.scss',
  shadow: true,
})
export class AirBadge {
  /** Badge text */
  @Prop() text!: string

  render(): JSX.Element {
    const { text } = this
    return (
      <div class="badge">
        <span class="badge-text" title={text}>
          {text}
        </span>
      </div>
    )
  }
}
